module.exports = __webpack_public_path__ + "static/media/main-first_section.112c369d.png";